import { apiFetch } from "./client";

export interface ProviderCatalogEntry {
  id: string;
  displayName: string;
  countries: string[];
  paymentMethods: string[];
  modes: string[];
  available: boolean;
  docsUrl?: string;
}

export interface ProviderCatalog {
  providers: ProviderCatalogEntry[];
}

export const listProviders = () => apiFetch<ProviderCatalog>("/providers");
